export enum PlanState {
    Unavailable = 0,
    Available = 1,
}
